export default __webpack_public_path__ + "static/media/B177.0985a13f.png";